<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id" style="    display: inline-block;
    float: left;
    margin-right: 20px;
    padding-top: 4px;">
    {{ props.label }}:
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div >
    <div style="display: flex;  flex-wrap: wrap;">
      <nb-radio [id]="id + '_' + 0"
                [checked]="isCheckedAll()"
                [formlyAttributes]="field" (valueChange)="onChange(0, $event)">
       All
      </nb-radio>
      <div *ngFor="let option of props.options; let i = index;"
           class="me-3"
      >
        <nb-radio [id]="id + '_' + i"
                     [checked]="isChecked(options)"
                     [formlyAttributes]="field" (valueChange)="onChange(option.value, $event)">
          {{ option.label }}  ({{ (option.count>0)?option.count:0 }})
        </nb-radio>
      </div>
    </div>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
